import axios from "axios";
import Cookies from "js-cookie";
import { withApiErrorResponse } from "../utils/apiError";
//get report list
const BASE_URL = process.env.REACT_APP_BASE_BACKEND_API_URL;

// Coalesces calls that overlap in-flight (e.g. the header renders the
// organization/department selector twice -- once for desktop, once for the
// mobile drawer -- and both mount at once, each independently calling this
// same fetch) into a single network request. Purely a network-layer dedup:
// once a call resolves (or fails) the next call fetches fresh again, so this
// changes nothing about data freshness or error handling, only removes the
// wasted duplicate round trip while requests are in flight together.
const inFlightRequests = new Map();
const dedupeInFlight = (key, factory) => {
  if (inFlightRequests.has(key)) {
    return inFlightRequests.get(key);
  }
  const promise = factory().finally(() => {
    inFlightRequests.delete(key);
  });
  inFlightRequests.set(key, promise);
  return promise;
};

export const fetchReportData = async (currentPage, pageSize, filters,selectedOrgName) => {
    const token = Cookies.get('accessToken');
    const {  ReportType, UserType, Status, fromDate, toDate } = filters;
  
    try {
      const response = await axios.get(
        `${BASE_URL}api/v1/report/report-list`,
        {
          params: {
            page: currentPage,
            size: pageSize,
            organizationName: selectedOrgName,
            userType: UserType ? UserType.toLowerCase():"",
            reportType: ReportType ? ReportType.toUpperCase() : "",
            status: Status,
            fromDate: fromDate,
            toDate: toDate
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (response.data?.body?.value?.reportList) {
        return {
          reportList: response.data.body.value.reportList,
          totalCount: response.data.body.value.totalCount,
        };
      } else {
        return { reportList: [], totalCount: 0 };
      }
    } catch (error) {
      console.error('An error occurred:', error);
      return { reportList: [], totalCount: 0 };
    }
  };

  //fetch orgnization
  export const fetchOrganizations = async () => {
    return dedupeInFlight('fetchOrganizations', async () => {
      const token = Cookies.get('accessToken');
      try {
        const response = await axios.get(`${BASE_URL}api/v1/organization/get-list`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (!response || !response.data || !response.data.header || response.data.header.code !== 600) {
          throw new Error('Failed to fetch organizations');
        }
        return response.data.body.value;
      } catch (error) {
        console.error('Error fetching organizations:', error);
        throw withApiErrorResponse(error);
      }
    });
  };

  //rc orgniztion
  export const fetchRcOrganizations = async () => {
    const token = Cookies.get('accessToken');
    try {
      const response = await axios.get(`${BASE_URL}api/v1/organization/get-list-rc`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response || !response.data || !response.data.header || response.data.header.code !== 600) {
        throw new Error('Failed to fetch organizations');
      }
      return response.data.body.value;
    } catch (error) {
      console.error('Error fetching organizations:', error);
      throw withApiErrorResponse(error);
    }
  };
  // get user name by userType and ornizationid
  export const getUserDetails = async (selectedOrgId, UserType) => {
    const token = Cookies.get('accessToken');
    try {
      const response = await axios.get(`${BASE_URL}api/v1/user/get-office-users`, {
        params: {
          organizationId: selectedOrgId,
          userType: UserType,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
  
      if (!response || !response.data || !response.data.header || response.data.header.code !== 600) {
        throw new Error('Failed to fetch user details');
      }
  
      return response.data.body.value;
    } catch (error) {
      console.error('Error fetching user details:', error);
      throw withApiErrorResponse(error);
    }
  };
  
  //make request for report
  export const requestReport = async ({ selecteduser, UserType, ReportType, startDate, endDate }) => {
    const token = Cookies.get('accessToken');
    try {
      const response = await axios.post(
        `${BASE_URL}api/v1/report/request`,
        {
          userId: selecteduser,
          userType: UserType,
          reportType: ReportType,
          fromDate: startDate,
          toDate: endDate,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
  
      const responseData = response.data;
      if (responseData.header.code === 600) {
        return responseData.body.value;
      } else {
        throw new Error(responseData.header.message || 'Error requesting report');
      }
    } catch (error) {
      console.error('Error requesting report:', error);
      throw withApiErrorResponse(error);
    }
  };


  // get organization by id 
  export const getOrganizationById = async (selectedOrgId) => {
    return dedupeInFlight(`getOrganizationById:${selectedOrgId}`, async () => {
    const token = Cookies.get('accessToken');
    try {
      const response = await axios.get(`${BASE_URL}api/v1/organization/get?id=${selectedOrgId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response || !response.data || !response.data.header || response.data.header.code !== 600) {
        throw new Error('Failed to fetch user details');
      }

      return response.data.body.value;
    } catch (error) {
      console.error('Error fetching user details:', error);
      throw withApiErrorResponse(error);
    }
    });
  };
